import "../../../styles/index.scss";
import "./index.scss";